// pages/Dashboard.jsx - SUPER CLEAR
import React from 'react';

const Dashboard = () => {
  return (
    <div className="p-8">
      <div className="bg-gradient-to-r from-red-500 to-pink-500 text-white p-8 rounded-2xl text-center">
        <h1 className="text-4xl font-bold mb-4">🎯 MAECHI DASHBOARD WORKING!</h1>
        <p className="text-xl">If you see this, your Dashboard is finally working!</p>
      </div>
      
      <div className="mt-8 grid grid-cols-2 gap-4">
        <div className="bg-blue-100 p-4 rounded-xl">
          <h3 className="font-bold text-blue-800">Test Card 1</h3>
        </div>
        <div className="bg-green-100 p-4 rounded-xl">
          <h3 className="font-bold text-green-800">Test Card 2</h3>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;